export enum UserAssignment {
    TARGETUSER = 0,
    CONTACTUSER = 1,
    WATCHER = 3,
    VERIFIER = 4
}